import { render, staticRenderFns } from "./DeviceDetails.vue?vue&type=template&id=12de8aad&scoped=true&"
import script from "./DeviceDetails.vue?vue&type=script&lang=js&"
export * from "./DeviceDetails.vue?vue&type=script&lang=js&"
import style0 from "./DeviceDetails.vue?vue&type=style&index=0&id=12de8aad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12de8aad",
  null
  
)

export default component.exports